import {Injectable} from '@angular/core'

import {Observable} from 'rxjs'
import {map} from 'rxjs/operators'

import {SearchFilter} from '@app/core/services/search/search-filter.interface'
import {DateFilter} from '@app/core/services/date-filter/date-filter.interface'

import {
  GenericListService,
  LoadRequest,
  LoadResult,
} from '../generic-list.service'
import {DataService} from '@app/core/services/data/data.service'
import {NotificationService} from '@app/core/services/notification.service'
import {LoggerService} from '@app/core/services/logger.service'
import {ContextService} from '@app/core/services/context.service'

import {
  ElasticQuery,
  TermFilter,
  RangeFilter,
} from '@app/core/services/rest-api.model'

export interface EventRequest extends LoadRequest {
  query: string
  sortField: string
  sortAsc: boolean
}

@Injectable()
export class EventListService extends GenericListService<object> {
  range: DateFilter = null
  filter: SearchFilter = null

  constructor(
    private dataSvc: DataService,
    protected notify: NotificationService,
    protected contextSvc: ContextService,
    protected logger: LoggerService,
  ) {
    super(notify, logger)
  }

  retrieve(request: LoadRequest): Observable<LoadResult<object>> {
    const elastic = new ElasticQuery('Events', '', request.count)

    elastic.offset = request.offset
    if (this.range) {
      elastic.addFilter(new RangeFilter(this.range.start, this.range.end))
    }
    elastic.addFilter(new TermFilter('terminalAccessDomain', request.domain))

    if (this.filter) {
      elastic.query = this.filter.query
      if (this.filter.asc === true) {
        elastic.sorts = [
          {field: '@timestamp', asc: true},
          {field: 'sequenceNumber', asc: true},
        ]
      } else {
        elastic.sorts = [
          {field: '@timestamp', asc: false},
          {field: 'sequenceNumber', asc: false},
        ]
      }
    } else {
      elastic.sorts = [
        {field: '@timestamp', asc: false},
        {field: 'sequenceNumber', asc: false},
      ]
    }

    return this.dataSvc.getData(elastic).pipe(
      map((res) => {
        const result: LoadResult<object> = {
          total: res.count,
          items: res.documents,
        }
        return result
      }),
    )
  }
}
